<template lang="pug">
.accounting-page.flex.column
  .input.flex.align-center.gap-10.mb-20
    .col.flex.column.align-start.gap-8
      .title.font-size-12 區間
      el-date-picker.date-range-input(@change="changeDate"
        v-model="times"
        type="daterange"
        range-separator="至")
    .col.flex.column.align-start.gap-8
      .title.font-size-12 專業人士
      pro-selector(v-model="professional", show-all, public-only, use-group)
    .col.flex.column.align-start.gap-8
      .title.font-size-12 財管
      .account-month-info.flex.align-center.gap-4
        span {{ searchMonthText }}
        i.el-icon-edit.clickable(@click="showAccountingMonthDialog")
    template(v-if="tabPage === 'project'")
      .col.flex.column.align-start.gap-8
        .title.font-size-12 專案
        el-select(v-model="project" filterable clearable)
          el-option-group(
            v-for="group in organizations"
            v-if="group.public"
            :key="group.id"
            :label="group.name")
            el-option(
              v-for="p in group.projects"
              :key="p.id"
              :label="`${group.name} - ${p.name}`"
              :value="`${p.id}`")
              span {{ p.name }}
    template(v-else)
      .col.flex.column.align-start.gap-8
        .title.font-size-12 支付狀態
        el-select(v-model="paymentStatus", @change="changePayment", clearable)
          el-option(value="notpaid", label="尚未支付")
          el-option(value="cash", label="現金支付")
          el-option(value="3rdparty", label="藍新金流")
          el-option(value="creditcard", label="信用卡支付")
          el-option(value="transfer", label="轉帳支付")
          el-option(value="project", label="專案支付")
    .col.flex.column.align-start.gap-8
      .title.font-size-12 確認狀態
      el-select(v-model="checkStatus", @change="changeCheckStatus", clearable)
        el-option(value="not_confirmed", label="尚未確認")
        el-option(value="confirmed", label="已確認")
        el-option(value="wrong_amount", label="金額錯誤")
        el-option(value="not_notified", label="未通知")
    template(v-if="tabPage === 'project' || tabPage === 'self'")
      .col.flex.column.align-start.gap-8
        .title.font-size-12 個案紀錄狀態
        el-select(v-model="hasRecord", @change="changeHasRecord", clearable)
          el-option(value="0", label="尚未完成")
          el-option(value="1", label="已完成")
  el-tabs.flex.column.fill(type="border-card", @tab-click="tabChange", v-model="tabPage", :lazy="true")
    el-tab-pane(label="自費", name="self")
      .flex.align-center
        el-button(type="primary", size="mini", @click="selectAll('selfList')") 選擇全部
        el-button(type="primary", size="mini", @click="unselectAll('selfList')") 取消全部選擇
        el-button(type="primary", size="mini", @click="setMonth('selfList')") 批次設定財管月
        el-button(v-if="isAdmin", type="warning", size="mini", @click="resetConfirmStatus('selfList')") 批次重設確認狀態
      reserve-list#self(:data="selfReserveDatas", @edit="openEdit", ref="selfList", @refresh="loadSelfData")
      .pagination.flex.align-center.justify-end
        el-pagination(
          layout="total, sizes, prev, pager, next, ->, jumper"
          :page-size.sync="selfLimit"
          :current-page.sync="selfCurrentPage"
          :total="selfTotal"
          :page-sizes="[50, 100, 200]"
          @current-change="loadData"
        )
    el-tab-pane(label="專案", name="project")
      .flex.align-center
        el-button(type="primary", size="mini", @click="selectAll('projectList')") 選擇全部
        el-button(type="primary", size="mini", @click="unselectAll('projectList')") 取消全部選擇
        el-button(type="primary", size="mini", @click="setMonth('projectList')") 批次設定財管月
        el-button(v-if="isAdmin", type="warning", size="mini", @click="resetConfirmStatus('projectList')") 批次重設確認狀態
      reserve-list#project(:data="projectReserveDatas", @edit="openEdit", ref="projectList", is-project, @refresh="loadProjectData")
      .pagination.flex.align-center.justify-end
        el-pagination(
          layout="total, sizes, prev, pager, next, ->, jumper"
          :page-size.sync="projectLimit"
          :current-page.sync="projectCurrentPage"
          :total="projectTotal"
          :page-sizes="[50, 100, 200]"
          @current-change="loadData"
        )
    el-tab-pane(label="活動", name="activity")
      .flex.align-center
        el-button(type="primary", size="mini", @click="selectAll('activityList')") 選擇全部
        el-button(type="primary", size="mini", @click="unselectAll('activityList')") 取消全部選擇
        el-button(type="primary", size="mini", @click="setMonth('activityList')") 批次設定財管月
      activity-list#activity(:data="activityDatas", @edit="openActivityEdit", ref="activityList", @refresh="loadActivityData")
      .pagination.flex.align-center.justify-end
        el-pagination(
          layout="total, sizes, prev, pager, next, ->, jumper"
          :page-size.sync="activityLimit"
          :current-page.sync="activityCurrentPage"
          :total="activityTotal"
          :page-sizes="[50, 100, 200]"
          @current-change="loadData"
        )
  appointment-edit(
    ref="appointmentEdit"
    @finish="loadData"
  )
  activity-editor(
    ref="activityEditor"
    @finish="loadData"
  )
  el-dialog(
    custom-class="no-close"
    :show-close="false"
    title="設定財管搜尋月份"
    width="350px"
    :visible.sync="monthDialogVisible")
    .flex.column.conditions.gap-20.p-20
      el-radio(v-model="searchMonthTypeInDialog", label="0") 不設定條件
      el-radio(v-model="searchMonthTypeInDialog", label="1") 僅顯示未設定財管月
      el-radio(v-model="searchMonthTypeInDialog", label="2") 指定財管月
      el-date-picker.minimize-picker(
        v-if="searchMonthTypeInDialog === '2'"
        type="month", v-model="accountingMonthInDialog")
      el-button(@click="closeAccountingMonthDialog") OK
  el-dialog(
    :show-close="false"
    title="批次設定財管月份"
    width="350px"
    :visible.sync="monthValueDialogVisible")
    .flex.column.conditions.gap-20
      el-date-picker.minimize-picker(
        type="month", v-model="monthToSet", placeholder="選擇月份")
      span.font-size-12 清空日期後按儲存，即清除所選項目的財管月
      .flex.align-center.gap-10
        el-button(type="primary", @click="closeSetMonthDialog(true)") 儲存
        el-button(@click="closeSetMonthDialog(false)") 取消
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getAccountingAppointments,
  getAccountingActivities,
  resetAppointmentConfirmStatus,
} from '@/api/accounting';
import { getOrganizations } from '@/api/project';
import AppointmentEditor from '@/components/drawers/AppointmentEdit.vue';
import ActivityEditorVue from '@/components/drawers/ActivityEditor.vue';
import ReserveList from './ReserveList.vue';
import ActivityList from './ActivityList.vue';

export default {
  components: {
    'reserve-list': ReserveList,
    'activity-list': ActivityList,
    'appointment-edit': AppointmentEditor,
    'activity-editor': ActivityEditorVue,
  },
  data() {
    return {
      times: [],
      professional: '',
      accountingMonth: new Date(),
      paymentStatus: '',
      tabPage: 'self',

      selfReserveDatas: [],
      selfLimit: 100,
      selfCurrentPage: 1,
      selfTotal: 0,
      projectReserveDatas: [],
      projectLimit: 100,
      projectCurrentPage: 1,
      projectTotal: 0,
      activityDatas: [],
      activityLimit: 100,
      activityCurrentPage: 1,
      activityTotal: 0,

      monthDialogVisible: false,
      searchMonthType: '0',

      accountingMonthInDialog: new Date(),
      searchMonthTypeInDialog: '0',

      setMonthTarget: '',
      monthValueDialogVisible: false,
      monthToSet: null,

      project: undefined,
      organizations: [],

      checkStatus: null,

      hasRecord: '',
    };
  },
  computed: {
    ...mapGetters(['isAdmin']),
    searchMonthText() {
      if (this.searchMonthType === '0') {
        return '不設定條件';
      } if (this.searchMonthType === '1') {
        return '僅顯示未設定財管月';
      }
      if (this.accountingMonth === null) {
        return '不設定條件';
      }
      return `${this.accountingMonth.getFullYear()}年${this.accountingMonth.getMonth() + 1}月`;
    },
  },
  watch: {
    accountingMonth() {
      if (this.accountingMonth === null) {
        this.searchMonthType = '0';
      }
    },
    selfLimit() {
      this.resetAllPages();
      this.loadData();
    },
    projectLimit() {
      this.resetAllPages();
      this.loadData();
    },
    activityLimit() {
      this.resetAllPages();
      this.loadData();
    },
    professional() {
      this.resetAllPages();
      this.loadData();
    },
    project() {
      this.resetAllPages();
      this.loadData();
    },
  },
  methods: {
    changeHasRecord() {
      this.resetAllPages();
      this.loadData();
    },
    changePayment() {
      this.resetAllPages();
      this.loadData();
    },
    changeCheckStatus() {
      this.resetAllPages();
      this.loadData();
    },
    resetAllPages() {
      this.selfCurrentPage = 1;
      this.projectCurrentPage = 1;
      this.activityCurrentPage = 1;
    },
    closeSetMonthDialog(save) {
      this.monthValueDialogVisible = false;
      if (!save) {
        this.monthToSet = null;
        return;
      }
      // monthToSet 為空時傳 null，代表清空財管月
      this.$refs[this.setMonthTarget].$emit('set-month', this.monthToSet ? new Date(this.monthToSet) : null);
      this.monthToSet = null;
      this.setMonthTarget = '';
    },
    selectAll(target) {
      this.$refs[target].$emit('select-all');
    },
    unselectAll(target) {
      this.$refs[target].$emit('unselect-all');
    },
    setMonth(target) {
      if (this.$refs[target].getCheckedList(target).length <= 0) {
        alert('請選擇至少一個預約');
        return;
      }
      this.setMonthTarget = target;
      this.monthValueDialogVisible = true;
    },
    async resetConfirmStatus(target) {
      const appointments = this.$refs[target].getCheckedList();
      if (appointments.length <= 0) {
        this.$showWarn('請選擇至少一個預約');
        return;
      }
      try {
        await this.$confirm('確定要重設所選預約的確認狀態嗎？', '重設確認狀態', {
          confirmButtonText: '重設',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } catch (e) {
        return;
      }
      let doneCount = 0;
      await this.$execWithLoading(async () => {
        await appointments.reduce((promise, appointment) => promise.then(async () => {
          await resetAppointmentConfirmStatus(appointment.id);
          doneCount += 1;
        }), Promise.resolve());
        this.$showSuccess('重設成功');
        return this.loadDataWithoutLoading();
      }, (e) => {
        let title = '重設確認狀態失敗';
        if (doneCount >= appointments.length) {
          // 全部重設成功、只有重新載入失敗
          title = '重設成功，但重新載入清單失敗';
        } else if (appointments.length > 1) {
          const failed = appointments[doneCount];
          const failedName = `${this.$timestampToDateWithDay(failed.start_at)} ${failed.user?.family_name || ''}${failed.user?.given_name || ''}`;
          title = `批次重設確認狀態中斷（共 ${appointments.length} 筆，已成功 ${doneCount} 筆；第 ${doneCount + 1} 筆「${failedName}」失敗，之後未處理）`;
        }
        this.$showAxiosException(title, e);
        // 部分已成功時重新載入清單，讓畫面與後端一致
        if (doneCount > 0 && doneCount < appointments.length) {
          this.loadData();
        }
      });
    },
    showAccountingMonthDialog() {
      this.monthDialogVisible = true;
      this.searchMonthTypeInDialog = this.searchMonthType;
      this.accountingMonthInDialog = this.accountingMonth;
    },
    closeAccountingMonthDialog() {
      this.monthDialogVisible = false;
      this.accountingMonth = this.accountingMonthInDialog;
      if (this.accountingMonthInDialog == null && this.searchMonthType === '2') {
        this.searchMonthType = '0';
        return;
      }
      this.searchMonthType = this.searchMonthTypeInDialog;
      this.resetAllPages();
      this.loadData();
    },
    setupDefaultTime() {
      if (this.times.length > 0) {
        return;
      }
      const start = new Date();
      const date = start.getDate();

      let monthShift = -1;
      if (date >= 16) {
        monthShift = 0;
      }
      start.setMonth(start.getMonth() + monthShift);
      start.setDate(1);
      start.setHours(0, 0, 0, 0);

      const tmp = new Date(start);
      tmp.setMonth(tmp.getMonth() + 1);
      const end = new Date(tmp.getTime() - 1);
      this.times = [start, end];
    },
    changeAccountingMonth() {
    },
    changeDate() {
      this.loadData();
    },
    tabChange() {
      return this.loadData();
    },
    getSelfPaidFilter() {
      return {
        ...this.getGeneralFilter(),
        payment_type: 'self_paid',
        page: this.selfCurrentPage - 1,
        limit: this.selfLimit,
      };
    },
    getProjectPaidFilter() {
      return {
        ...this.getGeneralFilter(),
        payment_type: 'project',
        page: this.projectCurrentPage - 1,
        limit: this.projectLimit,
        project_id: this.project,
      };
    },
    getGeneralFilter() {
      this.times[1].setHours(23, 59.0, 59, 999);
      const filter = {
        start_at: parseInt(this.times[0].getTime() / 1000, 10),
        end_at: parseInt(this.times[1].getTime() / 1000, 10),
        payment_status: this.paymentStatus,
        professional: this.professional,
        search_accounting_month: this.searchMonthType === '1' || this.searchMonthType === '2',
        confirm_status: this.checkStatus,
        has_record: this.hasRecord,
      };
      if (this.searchMonthType === '2') {
        filter.accounting_month = this.accountingMonth.getMonth() + 1;
        filter.accounting_year = this.accountingMonth.getFullYear();
      }
      return filter;
    },
    async loadData() {
      return this.$execWithLoading(async () => this.loadDataWithoutLoading(), (e) => {
        this.$showAxiosException('載入資料失敗', e);
      });
    },
    async loadDataWithoutLoading() {
      if (this.tabPage === 'self') {
        await this.loadSelfData();
      } else if (this.tabPage === 'project') {
        await this.loadProjectData();
      } else if (this.tabPage === 'activity') {
        await this.loadActivityData();
      }
      setTimeout(() => {
        this.$forceUpdate();
      }, 100);
    },
    async loadSelfData() {
      const rsp = await getAccountingAppointments(this.getSelfPaidFilter());
      this.selfReserveDatas = rsp.appointments;
      this.selfTotal = rsp.meta.total;
    },
    async loadProjectData() {
      const rsp = await getAccountingAppointments(this.getProjectPaidFilter());
      this.projectReserveDatas = rsp.appointments.map((a) => ({
        ...a,
        projectName: `${a.organization?.name} - ${a.project?.name}`,
      }));
      this.projectTotal = rsp.meta.total;
    },
    async loadActivityData() {
      const filter = {
        ...this.getGeneralFilter(),
        page: this.activityCurrentPage - 1,
        limit: this.activityLimit,
      };
      const rsp = await getAccountingActivities(filter);
      this.activityDatas = rsp.activities;
      this.activityTotal = rsp.meta.total;
    },
    openEdit(appointment) {
      this.$refs.appointmentEdit.$emit('show', appointment);
    },
    openActivityEdit(activity) {
      this.$refs.activityEditor.$emit('show', activity);
    },
    checkRoute() {
      const hashPart = window.location.hash.substring(1);
      const parts = hashPart.split('?');
      if (parts.length === 1) {
        return false;
      }
      const searchParams = new URLSearchParams(parts[1]);

      const professionalID = parseInt(searchParams.get('professional'), 10);
      const target = searchParams.get('type');
      const year = searchParams.get('year');
      const month = searchParams.get('month');
      const start = parseInt(searchParams.get('start'), 10);
      const end = parseInt(searchParams.get('end'), 10);

      this.professional = professionalID;
      this.searchMonthType = '2';
      this.accountingMonthInDialog = new Date(`${year}/${month}/1`);
      this.accountingMonth = new Date(`${year}/${month}/1`);
      this.times = [new Date(start * 1000), new Date(end * 1000)];
      this.tabPage = target;
      if (target === 'selfPaid') {
        this.tabPage = 'self';
      } else if (target === 'projectPaid') {
        this.tabPage = 'project';
      }

      return searchParams.has('professional');
    },
    async loadProjects() {
      const rsp = await getOrganizations();
      this.projectOrgMap = {};
      rsp.forEach((org) => {
        org.projects.forEach((p) => {
          this.projectOrgMap[p.id] = org.id;
        });
        // eslint-disable-next-line no-param-reassign
        org.projects = org.projects.filter((p) => p.public);
      });
      this.organizations = rsp;
    },
    initData() {
      this.$execWithLoading(async () => {
        this.setupDefaultTime();
        await this.loadProjects();
        await this.loadDataWithoutLoading();
      }, (e) => this.$showAxiosException('載入資料失敗', e));
    },
  },
  mounted() {
    this.checkRoute();
    this.initData();
  },
};
</script>

<style lang="scss" scoped>

.date-range-input {
  min-width: 320px;
}
</style>

<style lang="scss">
.accounting-page {
  .el-tabs__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    .el-tab-pane {
      flex: 1;
      display: flex;
      flex-direction: column;
      .el-table {
        flex: 1;
        display: flex;
        flex-direction: column;
        .el-table__body-wrapper {
          flex: 1;
        }
      }
    }
  }
  .account-month-info {
    height: 40px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 5px 10px;
    background: white;
  }
  .all-btn {
    max-width: 80px;
  }
}
</style>

<style lang="scss">
.accounting-page {
  .el-tabs {
    overflow: hidden;
    .el-tabs__content {
      & > div {
        overflow: hidden;
        .el-table__body-wrapper {
          overflow-y: scroll;
          overflow-y: auto;
        }
      }
    }
  }
}
</style>
